import get from 'lodash/get'

import { getBrandingStats } from '../api/mikasa/requests'

import {
  FETCH_BRANDING_STATS_REQUEST,
  FETCH_BRANDING_STATS_SUCCESS,
  FETCH_BRANDING_STATS_FAILURE,
} from './actionTypes'

export const fetchBrandingStats =
  ({ sponsorProfileId, zip }) =>
  async (dispatch, _getState) => {
    dispatch({
      type: FETCH_BRANDING_STATS_REQUEST,
    })

    try {
      const response = await getBrandingStats({ sponsorProfileId, zip })
      const brandingData = get(response, 'data')

      dispatch({
        type: FETCH_BRANDING_STATS_SUCCESS,
        data: brandingData,
      })
    } catch (e) {
      dispatch({
        type: FETCH_BRANDING_STATS_FAILURE,
      })
    }
  }
